<template>
    <div class="flex flex-wrap">
        <div class="w-full md:w-3/4 md:pr-20">
            <h1 class="mt-2 mb-4 font-sans text-n-gray-dark">Organization Details</h1>
            <organization-edit></organization-edit>
        </div>
        <div class="w-full md:w-1/4 md:pt-40">
            <div class="sidebar-block border-t-5 border-black pt-3">
                <public-profile-link></public-profile-link>
                <h2 class="text-lg mb-5 font-sans text-n-gray-dark">Help with Public Profile</h2>
                <ul class="list-reset mb-10 text-base">
                    <li class="mb-2"><a target="_blank" href="https://help.letsreimagine.org/hc/en-us/sections/360008463452-Creating-your-account-and-public-profile">Profile and Account Guide</a></li>
                    <li class="mb-2"><a target="_blank" href="https://help.letsreimagine.org/hc/en-us/articles/360041721452-Example-public-profile">Example Profile Page</a></li>
                </ul>

                <support></support>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import UrlInput from '../global/UrlInput.vue'
    import OrganizationEdit from './OrganizationEdit.vue'
    import Support from '../global/Support.vue'
    import PublicProfileLink from '../global/PublicProfileLink.vue'

    export default {
        name: 'OrganizationProfile',
        title: 'Organization Profile',
        mixins: [],
        components: {
            UrlInput,
            OrganizationEdit,
            Support,
            PublicProfileLink
        },
        data() {
            return {}
        },
        computed: {},
        watch: {},
        methods: {},
        mounted() {}
    }
</script>
